import React, { useState } from 'react';
import axios from 'axios';
import './CreatePost.css';
import API_URL from '../config';


const CreatePost = ({ onPostCreated }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    content: '',
    category: 'noticia',
    author: '',
    imageUrl: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    // Validación básica
    if (!formData.title || !formData.description || !formData.content || !formData.author) {
      setError('Por favor completa todos los campos obligatorios');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API_URL}/api/posts`, {
        ...formData,
        published: true,
      });

      setSuccess(true);
      setFormData({
        title: '',
        description: '',
        content: '',
        category: 'noticia',
        author: '',
        imageUrl: '',
      });

      // Llama la función para actualizar el feed
      if (onPostCreated) {
        onPostCreated();
      }

      // Limpia el mensaje de éxito después de 3 segundos
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError('Error al crear el post. Intenta de nuevo.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-post-container">
      <div className="form-wrapper">
        <h1>Crear Nuevo Post</h1>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">¡Post creado exitosamente!</div>}

        <form onSubmit={handleSubmit} className="post-form">
          <div className="form-group">
            <label htmlFor="title">Título *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Ingresa el título del post"
              maxLength={150}
            />
            <small>{formData.title.length}/150</small>
          </div>

          <div className="form-group">
            <label htmlFor="description">Descripción *</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Escribe una descripción breve"
              maxLength={300}
              rows={3}
            />
            <small>{formData.description.length}/300</small>
          </div>

          <div className="form-group">
            <label htmlFor="content">Contenido *</label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleChange}
              placeholder="Escribe el contenido completo del post"
              rows={8}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="category">Categoría *</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="noticia">Noticia</option>
                <option value="opinión">Opinión</option>
                <option value="review-musical">Review Musical</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="author">Autor *</label>
              <input
                type="text"
                id="author"
                name="author"
                value={formData.author}
                onChange={handleChange}
                placeholder="Tu nombre"
                maxLength={50}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="imageUrl">URL de la imagen</label>
            <input
              type="url"
              id="imageUrl"
              name="imageUrl"
              value={formData.imageUrl}
              onChange={handleChange}
              placeholder="https://ejemplo.com/imagen.jpg"
            />
          </div>

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Creando...' : 'Publicar Post'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreatePost;